/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllExecutionsAvailableByFacilityId200ResponseDataInner } from './FindAllExecutionsAvailableByFacilityId200ResponseDataInner';
import {
    FindAllExecutionsAvailableByFacilityId200ResponseDataInnerFromJSON,
    FindAllExecutionsAvailableByFacilityId200ResponseDataInnerFromJSONTyped,
    FindAllExecutionsAvailableByFacilityId200ResponseDataInnerToJSON,
} from './FindAllExecutionsAvailableByFacilityId200ResponseDataInner';

/**
 * 
 * @export
 * @interface FindAllExecutionsAvailableByFacilityId200Response
 */
export interface FindAllExecutionsAvailableByFacilityId200Response {
    /**
     * 
     * @type {Array<FindAllExecutionsAvailableByFacilityId200ResponseDataInner>}
     * @memberof FindAllExecutionsAvailableByFacilityId200Response
     */
    data?: Array<FindAllExecutionsAvailableByFacilityId200ResponseDataInner>;
}

/**
 * Check if a given object implements the FindAllExecutionsAvailableByFacilityId200Response interface.
 */
export function instanceOfFindAllExecutionsAvailableByFacilityId200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllExecutionsAvailableByFacilityId200ResponseFromJSON(json: any): FindAllExecutionsAvailableByFacilityId200Response {
    return FindAllExecutionsAvailableByFacilityId200ResponseFromJSONTyped(json, false);
}

export function FindAllExecutionsAvailableByFacilityId200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllExecutionsAvailableByFacilityId200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(FindAllExecutionsAvailableByFacilityId200ResponseDataInnerFromJSON)),
    };
}

export function FindAllExecutionsAvailableByFacilityId200ResponseToJSON(value?: FindAllExecutionsAvailableByFacilityId200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(FindAllExecutionsAvailableByFacilityId200ResponseDataInnerToJSON)),
    };
}

